import {
  CAlert, CButton, CCol, CContainer, CForm, CFormGroup,
  CInput, CLabel, CModal, CModalBody, CModalFooter, CModalHeader,
  CModalTitle, CRow, CSpinner, CSwitch, CTextarea
} from '@coreui/react';
import React, { useEffect, useState } from 'react';
import Notify from '../../utils/Notify';

export default function AddVerseModal(props) {
  const book = props.book
  const bookRef = props.bookRef
  const chapter = props.chapter
  const verseModel = {
    number: '',
    content: '',
    paragraph: false,
    section: false,
    sectionTitle: '',
    references: '',
  }
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [verse, setVerse] = useState(verseModel)

  function handleVerseChange(evt) {
    setError('')
    let value = evt.target.value;
    let name = evt.target.name;

    setVerse({ ...verse, [name]: name == 'number' ? parseInt(value) : value })
  }

  function validateVerse() {
    if (!verse.number) {
      setError('Enter Verse number')
      return false;
    } else if (!verse.content) {
      setError('Enter Content')
      return false
    }

    return true
  }

  async function handleSubmit() {
    setLoading(true)

    if (!validateVerse()) {
      setLoading(false)
      return
    }

    try {
      verse.content = verse.content.toString().replace('_', 'ṭ')
      verse.sectionTitle = verse.sectionTitle.toString().replace('_', 'ṭ')

      var exist = chapter.verses.find(item => item.number == verse.number)
      if (exist != undefined) {
        chapter.verses = chapter.verses.map(item => {
          if (item.number == verse.number) {
            return verse
          } else {
            return item
          }
        })
      } else {
        chapter.verses.push(verse)
      }

      book.chapters = book.chapters.map(item => {
        if (item.number == chapter.number) {
          return chapter
        } else {
          return item
        }
      })

      await bookRef.doc(book.number.toString()).set(book)

      setLoading(false)
      props.onClose()
      let message = 'Verse added successfully.'

      if (props.verse) {
        message = 'Verse updated successfully.'
      }
      Notify.success(message)
    } catch (error) {
      setError('Something went wrong. Please try again.')
      setLoading(false)
    }
  }

  useEffect(() => {
    if (props.verse) {
      setVerse(props.verse)
    }
  }, [])

  return (
    <>
      <CModal
        show={props.show}
        centered={false}
        size="lg"
        onClose={() => props.onClose()}
        className="border-dark"
      >
        <CModalHeader>
          <CModalTitle>{props.verse ? 'Edit' : 'Add'} verse</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CContainer fluid>
            <CRow>
              {
                error && <CAlert color="danger" className="w-100">{error}</CAlert>
              }
              <CCol sm="12">
                <CForm onSubmit={e => {
                  e.preventDefault()
                  handleSubmit()
                }}>
                  <CFormGroup>
                    <CLabel>Verse Number</CLabel>
                    <CInput
                      disabled={props.verse}
                      value={verse.number}
                      type="number"
                      name="number"
                      placeholder="Enter Verse Number"
                      onChange={(e) => handleVerseChange(e)}
                    />
                  </CFormGroup>

                  <CFormGroup>
                    <CLabel>Content</CLabel>
                    <CTextarea
                      onChange={(e) => handleVerseChange(e)}
                      name="content"
                      value={verse.content}
                      rows="3"
                    />
                  </CFormGroup>
                  <CFormGroup className="w-100">
                    <CLabel>References <small>(Optional)</small></CLabel>
                    <CInput
                      className="w-100"
                      value={verse.references}
                      type="text"
                      name="references"
                      placeholder="Enter references"
                      onChange={(e) => handleVerseChange(e)}
                    />
                  </CFormGroup>
                  <CFormGroup>
                    <CLabel>Start new Paragraph?</CLabel>
                    <div>
                      <CSwitch
                        className="text-right"
                        checked={verse.paragraph}
                        color="dark"
                        size="lg"
                        variant="3d"
                        shape="pill"
                        onChange={() => setVerse({ ...verse, paragraph: !verse.paragraph })}
                      />
                    </div>
                  </CFormGroup>

                  <CFormGroup>
                    <CLabel>Start new Section?</CLabel>
                    <div>
                      <CSwitch
                        className="text-right"
                        checked={verse.section}
                        color="dark"
                        size="lg"
                        variant="3d"
                        shape="pill"
                        onChange={() => setVerse({ ...verse, section: !verse.section })}
                      />
                    </div>
                  </CFormGroup>
                  {
                    verse.section &&
                    (
                      <CFormGroup>
                        <CLabel>Section Title</CLabel>
                        <CInput
                          type="text"
                          onChange={(e) => handleVerseChange(e)}
                          name="sectionTitle"
                          value={verse.sectionTitle}
                        />
                      </CFormGroup>
                    )
                  }
                </CForm>
              </CCol>
            </CRow>
          </CContainer>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="danger" className="btn-sm pl-4 pr-4"
            disabled={loading}
            onClick={() => props.onClose()}>Cancel</CButton>
          <CButton color="dark" className="btn-sm pl-4 pr-4"
            disabled={loading}
            onClick={e => {
              e.preventDefault()
              handleSubmit()
            }}>
            {
              loading ? (
                <>
                  <CSpinner component="span" size="sm" aria-hidden="true" /> Saving...
                </>
              ) : 'Save'
            }
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}
